import RtlProvider from "./RtlProvider";
import { ToastContainer } from "react-toastify";
import { ErrorBoundary } from "react-error-boundary";
import { AuthProvider } from "@features/auth/contexts/AuthContext";
import StoreProvider from "./StoreProvider";
import AppThemeProvider from "./AppThemeProvider";
import { ErrorFallback } from "@shared/ui/errors";

interface AppProvidersProps {
  children: React.ReactNode;
}

export default function AppProviders({ children }: AppProvidersProps) {
  return (
    <RtlProvider>
      <StoreProvider>
        <AuthProvider>
          <ErrorBoundary fallbackRender={ErrorFallback}>
            <AppThemeProvider>{children}</AppThemeProvider>
          </ErrorBoundary>
          <ToastContainer
            position="bottom-center"
            autoClose={2000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </AuthProvider>
      </StoreProvider>
    </RtlProvider>
  );
}
